<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('certificate.type_title')"/>
        <div class="col-sm-12 nopads my-2">
            <certificate-type-list
              :results="results"
              @add="add"
              @edit="edit"
            />
        </div>
        <base-modal v-if="editMode" hide-footer hide-header size="lg" @close="editMode = false">
            <certificate-type-editor
              :certificate-type="certificateType"
              @close="showList"
              @close-and-update="closeAndUpdate"
            />
        </base-modal>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '.././mixins/RestApiMixin'
import CertificateTypeList from './CertificateTypeList'
import CertificateTypeEditor from './CertificateTypeEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'CertificateTypes',
    components: {BaseModal, Navbar, CertificateTypeList, CertificateTypeEditor},
    mixins: [restApi],
    data: function () {
        return {
            results: [],
            editMode: false,
            loading: false,
            certificateType: null
        }
    },
    mounted: function () {
        this.fetchCertificateTypes()
    },
    methods: {
        fetchCertificateTypes: function () {
            this.loading = true
            this.restFetch(this.certificateTypeUrl, this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },
        add: function () {
            this.certificateType = {id: -1, name: '', is_expiring: true}
            this.editMode = true
        },
        edit: function (certificateType) {
            this.certificateType = certificateType
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.fetchCertificateTypes()
            this.showList()
        }
    }
}
</script>
